module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[56]177.1e2f5dd.woff2";